// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1617":"c73b47e5","4406":"c73b47e5","7235":"eaa1432c"}[chunkId] + ".chunk.css";
};